<template>
  <a-modal title="导航编辑" :visible="visible" :confirm-loading="confirmLoading" @ok="handleOk" @cancel="handleCancel"
    class="set-navigation-modal">
    <a-spin :spinning="$store.state.tabLoding" :indicator="indicator">
      <div class="switch-table-box">
        <div class="switch-table">
          <div v-for="(item,index) in menuList" :key="index" class="switch-table-sell">
            <div class="switch-table-title">
              <span>{{ item.name }}</span>
            </div>
            <div class="switch-list">
              <a-switch :value="item.name" :checked="item.checked" @change="onChange" />
            </div>
          </div>
        </div>
      </div>
    </a-spin>
  </a-modal>
</template>

<script>
import { getListEditable, setupdateEditable } from "@/utils/api";
export default {
  name: "setNavigation",
  data() {
    return {
      visible: false,
      confirmLoading: false,
      sellList: [],
      repertoryList: [],
      procurementList: [],
      setDataList: [],
      menuList: [],
      noteList: [],
      closelist: [],
      openList: [],
      spinning: false,
      indicator: <a-icon type="loading" style="font-size: 24px" spin />,
    };
  },
  props: {
    sell: {
      type: Array,
      default: () => {
        return [];
      },
    },
    repertory: {
      type: Array,
      default: () => {
        return [];
      },
    },
    procurement: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  mounted() {
    this.sellList = this.sell;
    this.repertoryList = this.repertory;
    this.procurementList = this.procurement;
  },
  methods: {
    showModal() {
      this.visible = true;
      this.setDataList = [];
      this.getEditableList();
    },
    handleOk(e) {
      let List = [];
      let params = this.menuList;
      let header = {};
      let data = {
        companyStoreId: this.$store.state.userInfo.companyStoreId,
        companyId: this.$store.state.userInfo.companyId,
      };
      this.$store.state.tabLoding = true;
      setupdateEditable(params, header, data).then((res) => {
        if (res.code == 200) {
          this.visible = false;
          this.$emit("btnColse");
          this.$store.state.tabLoding = false;
        } else {
          this.$message.error(res.logMessage)
        }
      });
    },
    handleCancel(e) {
      this.visible = false;
    },
    onChange(checked, e) {
      this.menuList.map((item, index) => {
        if (item.name == e.target.value) {
          if (checked) {
            item.checked = true;
            item.closeFlag = "0";
          } else {
            item.checked = false;
            item.closeFlag = "1";
          }
          this.menuList.splice(index, 1, item);
        }
      });
    },
    // 获取
    getEditableList() {
      let params = {};
      let header = {};
      let data = {
        companyStoreId: this.$store.state.userInfo.companyStoreId,
      };
      getListEditable(params, header, data).then((res) => {
        if (res.code == 200) {
          res.result.map((item) => {
            if (item.closeFlag == 1) {
              item.checked = false;
            } else {
              item.checked = true;
            }
          });
          this.menuList = res.result;
          this.noteList = res.result;
        } else {
          this.$message.error(res.logMessage)
        }
      });
    },
  },
};
</script>
<style lang="scss">
.set-navigation-modal {
  width: 650px !important;
  // height: 566px;
  .ant-modal-content,
  .ant-modal-header {
    border-radius: 10px;
  }
  .ant-modal-body {
    display: flex;
    justify-content: center;
    padding-top: 10px;
  }
  .ant-modal-title {
    font-size: 18px;
  }
  .switch-table-box {
    width: 502px;
    border: 1px solid #dddddd;
    border-bottom: 0;
    margin: 0 auto;
    .switch-table {
      .switch-table-sell,
      .switch-table-repertory,
      .switch-table-procurement {
        width: 500px;
        display: flex;
        justify-content: space-between;
        .switch-table-title,
        .switch-list {
          width: 250px;
          height: 50px;
          border-bottom: 1px solid #dddddd;
        }
        .switch-table-title {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          padding-left: 78px;
          color: #555555;
        }
        .switch-list {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          padding-right: 64px;
        }
      }
    }
  }
  .ant-modal-footer {
    padding: 10px 0 32px 0;
  }
}
</style>